<template>
  <v-container
    v-if="dataOptions.input"
    class="option-component d-flex justify-center">
    <v-checkbox
      v-if="hasAccept"
      v-model="accept"
      :label="dataOptions.checkbox.label"
      @change="changeTerm" />
    <h2
      v-if="dataOptions.legend"
      class="legend darkGray--text">
      {{ dataOptions.legend }}
    </h2>

    <v-select
      v-if="hasManyOptions && isMobile"
      v-model="selected"
      :items="dataOptions.options"
      item-text="label"
      item-value="value"
      label="Escolha"
      single-line
      @input="changeSelect" />

    <v-btn
      v-for="(option, index) in dataOptions.options"
      v-else
      :ref="`btn${index + 1}`"
      :key="index"
      :color="option.style"
      :disabled="option.disabled"
      class="option-btn"
      width="168"
      depressed
      dark
      @click="send(index, option.value)">
      {{ option.label }}
    </v-btn>
  </v-container>
  <message
    v-else
    :record="record" />
</template>

<script>
  import Message from './Message'
  import chatUiMixin from '@/mixins/chat-ui'

  export default {
    components: { Message },
    mixins: [ chatUiMixin ],
    data () {
      return {
        accept: true,
        selected: ''
      }
    },
    computed: {
      dataOptions () {
        return this.record.data
      },
      hasAccept () {
        // if (this.record.data.checkbox) {
        //   this.accept = false
        // }
        return this.record.data.checkbox
      },
      hasManyOptions () {
        return this.dataOptions.options.length > 2
      }
    },
    mounted () {
      this.$nextTick(() => this.startOptionsAnimation())
    },
    methods: {
      send (index, value) {
        let data = {
          slug: this.slug,
          value,
          topic: this.$route.params.caseId
        }
        this.endOptionsAnimation(index, data)
      },
      changeSelect () {
        let data = {
          slug: this.slug,
          value: this.selected,
          topic: this.$route.params.caseId
        }
        this.endOptionsAnimation(1, data)
      },
      startOptionsAnimation () {
        let children = this.$el.children
        let listTypes = [...children].filter(elm => elm.type === 'button')

        listTypes.map((elem, index) => {

          if (this.animeComponent) {
            this
              .anime
              .timeline({ delay: 200 * (index + 1) })
              .add({
                targets: elem,
                duration: 500,
                opacity: [0, 1],
                scale: [0, 1]
              })
          } else {
            this
              .anime
              .timeline({ loop: false })
              .add({
                targets: elem,
                opacity: [1],
                scale: [1]
              })
          }
        })
      },
      endOptionsAnimation (index, option) {
        let children = this.$el.children
        let listTypes = [...children].filter(elm => elm.type === 'button')
        let removedChild = listTypes[index]

        listTypes.splice(index, 1)
        listTypes.unshift(removedChild)

        listTypes.map((elem, index) => {
          this
            .anime
            .timeline({ delay: 100 * index })
            .add({
              targets: elem,
              opacity: [1, 0],
              scale: [1, 0]
            })
        })

        // delay after selected
        setTimeout(() => {
          this.$emit('send', option)
        }, 100 * children.length)
      },
      changeTerm (isChecked) {
        this.dataOptions.options[0].disabled = !isChecked
      }
    }
  }
</script>

<style lang="sass">
  @import '../../assets/style/variables'

  .option-btn,
  .legend,
  .checkbox
    opacity: 0

  .option-btn
    margin: 0 8px

  .option-component
    flex-wrap: wrap
    background: #F8F8F9

    select
      border: 1px solid $gray
      padding: 10px 20px

    .legend
      top: 5px
      position: absolute
      text-align: center
      font-size: 16px
      font-weight: 400

    .checkbox
      left: calc(50% - 260px)
      top: -30px
      position: absolute

  @media screen and (max-width: $max-mobile)
    .option-component
      bottom: 0

      .checkbox
        left: 10px
        top: -25px

        label
          font-size: 14px
          line-height: 1.4
          text-overflow: initial
          overflow: inherit
          white-space: initial
          max-width: 75%
</style>
